module.exports = __webpack_public_path__ + "img/icon-exit.64ec880e.svg";